const entrepriseDashboardGuideSteps = [
  {
    target: '.guide-dashboard',
    content: "Tableau de bord : Bienvenue sur votre espace Entreprise. Retrouvez ici une vue d’ensemble de vos recrutements et de vos indicateurs clés."
  },
  {
    target: '.guide-missions',
    content: "Missions : Créez, suivez et mettez à jour vos missions IT en toute simplicité. Visualisez leur avancement en temps réel."
  },
  {
    target: '.guide-candidatures',
    content: "Candidatures : Accédez à toutes les candidatures reçues, suivez leur progression et échangez facilement avec les recruteurs."
  },
  {
    target: '.guide-statistiques',
    content: "Statistiques : Analysez vos chiffres : missions actives, candidatures en cours et recrutements finalisés."
  },
  {
    target: '.guide-mes-factures',
    content: "Mes factures : Consultez vos factures et le montant total de vos recrutements validés."
  },
  {
    target: '.guide-factures-estimees',
    content: "Dépenses prévisionnelles : Anticipez vos dépenses liées aux missions en cours et suivez vos engagements financiers en un coup d’œil."
  },
  {
    target: '.guide-top-recruteurs',
    content: "Top recruteurs : Découvrez les recruteurs ayant positionné le plus de profils validés sur vos missions."
  }
];

export default entrepriseDashboardGuideSteps;
